<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>CMS Custom Field</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">CMS Custom Field</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'CMSCustomFieldList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>

                  <li><strong>ID</strong> {{ value.id }}</li>

                  <li><strong>Field Name</strong> {{ value.field_name }}</li>

                  <li><strong>Page</strong>
                    <span v-if="!_.isNil(value.page_id)">{{ pre.page_id[value.page_id] }}</span>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">CMS Custom Field Details</h3>
            </div>
            <!-- /.card-header -->
            <div class="card-body table-responsive p-0">
              <table class="table table-hover text-nowrap">
                <thead>
                <tr>

                  <th>ID</th>
                  <th>Field Label</th>
                  <th>Field Type</th>
<!--                  <th>Number of Entry</th>
                  <th>Field Extras</th>
                  <th>fields_extras_additional</th>-->
                </tr>
                </thead>
                <tbody>
                <tr v-for="(val, index) in value.cms_custom_field_details">

                  <td>{{ val.id }}</td>
                  <td>{{ val.field_label }}</td>
                  <td>{{ val.field_type }}</td>
<!--                  <td>{{ val.number_of_entry }}</td>
                  <td>{{ val.fields_extras }}</td>
                  <td>{{ val.fields_extras_additional }}</td>-->
                </tr>
                </tbody>
              </table>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
      </div>

    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import {DepartmentsAPI} from "@/services/api";
import axios from "axios";

const fileDownload = require("js-file-download")
import {Notification} from "element-ui";


export default {
  name: "CMSCustomFieldShow",
  metaInfo: {
    title: "CMS Custom Field | Dotlines"
  },
  data: () => ({
    value: {
      cms_custom_field_details: [],
    },
    pre: {
      page_id: [],
    },
    is_loading: false
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    pageIdOptions: function () {
      return new Promise(resolve => {
        axios.get("/get-dropdown-options/1")
          .then(response => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.pageIdOptions().then(page_id => {
        this.pre.page_id = page_id;
      });


      await this.getDetail(this.params.id).then(response => {
        this.value = response.data;
      });

      this.is_loading = false;
    },
    downloadFile: function (url) {
      this.is_loading = true;
      axios.get(this.API_ASSET_UPLOAD_URL + url, {responseType: "arraybuffer"})
        .then(response => {
          fileDownload(response.data, url.replaceAll("/", "-"));
          Notification.success({
            title: "Download Completed",
            message: "Download completed successfully",
            type: "success"
          });
        })
        .catch(error => {
          Notification.error({title: "Download Failed", message: "Failed to download", type: "error"});
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/cms_custom_fields/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          })
          .finally(() => {
          });
      });
    },
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>
